export default {
  // Data initializationが済んでいるか
  initialized: false,
  user: {
    id: null, // Number
    name: null, // String
    roleId: null // Number
  },
  config: {
    useManualSupplyRegistration: false // Show manual supply button?
  },
  company: {
    id: null, // Number
    name: '' // String
  },
  // Number || undefined ← ユーザーが配送員の場合所属エリアのID
  deliveryGroupId: null,
  // String - CRUDの結果を表示するスナックバーテキスト
  globalSnackBarText: '',
  // アンケートのDialogを表示するため
  showQuestionnaire: false
}
